<template>
  <div class="home_page flex-col">
    <div class="hero_section flex-col">
      <div class="cta_banner flex-col">
        <span class="cta_message">灵智鸟编程学习平台，现已正式开放！</span>
      </div>
      <div class="navigation_bar flex-row">
        <span class="brand_name">灵智鸟</span>
        <span
          class="teacher_portal_link"
          @click="onClickToTeacher"
          >教师平台</span
        >
      </div>
      <div class="logo_container flex-col">
        <img
          class="brand_logo"
          referrerpolicy="no-referrer"
          src="../assets/logo.png"
        />
      </div>
      <div class="student_entry_button flex-row">
        <img
          class="entry_icon"
          referrerpolicy="no-referrer"
          src="../assets/home/FigmaDDSSlicePNG8191954b856518c96bd8ad572404cf3f.png"
        />
        <span
          class="entry_text"
          @click="onClick"
          >学生入口</span
        >
      </div>
    </div>
    <div class="footer_section flex-col">
      <div class="footer_content flex-col">
        <div class="footer_background flex-col">
          <div class="footer_links flex-row">
            <span class="contact_link">联系我们</span>
            <span class="terms_link">条款及细则</span>
            <span class="privacy_link">隐私政策</span>
          </div>
          <img
            class="footer_character"
            referrerpolicy="no-referrer"
            src="../assets/home/FigmaDDSSlicePNG31e3f1ee014f2ea5a3866873e01e80f2.png"
          />
          <div class="decoration_container flex-col">
            <img
              class="decoration_image"
              referrerpolicy="no-referrer"
              src="../assets/home/FigmaDDSSlicePNG8263c3a17f2c70421f5a6d5bc4c193d6.png"
            />
          </div>
        </div>
      </div>
      <img
        class="background_decoration"
        referrerpolicy="no-referrer"
        src="../assets/home/FigmaDDSSlicePNG513b32cb0bdfa39ad50bc5ae83db5db0.png"
      />
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router"
const router = useRouter()

const onClick = () => {
  router.push({ path: "/student/login" })
}

const onClickToTeacher = () => {
  router.push({ path: "/teacher/login" })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.home_page {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 100%;
  height: 56.25vw;
  overflow: hidden;
}

.hero_section {
  height: 33.34vw;
  background: url(../assets/home/FigmaDDSSlicePNG0ccc123badada620e407da647618b622.png)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 1.1vw;
  width: 100vw;
  position: relative;
}

.cta_banner {
  background-color: rgba(69, 95, 237, 1);
  height: 4.54vw;
  margin-top: 28.81vw;
  width: 72.24vw;
}

.cta_message {
  width: 24.8vw;
  height: 1.93vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.45vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 1.46vw;
  margin: 1.19vw 0 0 42.5vw;
}

.navigation_bar {
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 0;
  top: -1.09vw;
  width: 100vw;
  height: 4.07vw;
}

.brand_name {
  width: 5vw;
  height: 2.19vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.66vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.93vw 0 0 10.67vw;
}

.teacher_portal_link {
  width: 7.5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 1.19vw 2.44vw 0 74.37vw;
  cursor: pointer;
}

.logo_container {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 50%;
  height: 7.71vw;
  width: 7.71vw;
  position: absolute;
  left: 2.82vw;
  top: -2.23vw;
}

.brand_logo {
  width: 6.57vw;
  height: 5.11vw;
  margin: 1.35vw 0 0 0.62vw;
}

.student_entry_button {
  background-color: rgba(243, 71, 150, 1);
  border-radius: 64px 64px 64px 64px;
  position: absolute;
  left: 69.02vw;
  top: 27.3vw;
  width: 31.05vw;
  height: 6.05vw;
}

.entry_icon {
  width: 2.5vw;
  height: 2.5vw;
  margin: 1.92vw 0 0 2.34vw;
}

.entry_text {
  width: 4.17vw;
  height: 2.77vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 2.08vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 2.09vw;
  margin: 1.9vw 20.78vw 0 1.25vw;
  cursor: pointer;
}

.footer_section {
  position: absolute;
  left: 0;
  top: 34.43vw;
  width: 100vw;
  height: 21.88vw;
}

.footer_content {
  background-color: rgba(239, 246, 255, 1);
  height: 20.47vw;
  width: 100vw;
  position: absolute;
  left: 0;
  top: -0.36vw;
}

.footer_background {
  background-image: linear-gradient(
    180deg,
    rgba(238, 244, 249, 0) 0,
    rgba(115, 146, 176, 0.18) 100%
  );
  height: 12.77vw;
  margin-top: 9.43vw;
  width: 100vw;
  position: relative;
}

.footer_links {
  background-color: rgba(247, 251, 255, 1);
  width: 100vw;
  height: 1.72vw;
  margin-top: 11.05vw;
}

.contact_link {
  width: 3.34vw;
  height: 1.1vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 0.83vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.84vw;
  margin: 0.31vw 0 0 42.5vw;
}

.terms_link {
  width: 4.17vw;
  height: 1.1vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 0.83vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.84vw;
  margin: 0.31vw 0 0 2.08vw;
}

.privacy_link {
  width: 3.34vw;
  height: 1.1vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 0.83vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 0.84vw;
  margin: 0.31vw 42.5vw 0 2.08vw;
}

.footer_character {
  position: absolute;
  left: 59.12vw;
  top: -4.06vw;
  width: 19.28vw;
  height: 12.24vw;
}

.decoration_container {
  box-shadow: none;
  height: 16.95vw;
  width: 23.1vw;
  position: absolute;
  left: 37.48vw;
  top: -8.19vw;
}

.decoration_image {
  width: 23.1vw;
  height: 16.95vw;
  margin: 0.78vw 0 0 0.72vw;
}

.background_decoration {
  position: absolute;
  left: 15.79vw;
  top: -5.1vw;
  width: 37.92vw;
  height: 25.21vw;
}
</style>
